import useQuotaMetricColumns from "./useQuotaMetricColumns";
import { Quota } from "src/app/types/quota";
import SimpleTable from "../SimpleTable/SimpleTable";

export interface IQuotaMetricGrid {
    quotaList?: Array<Quota>;
}

const QuotaMetricGrid = (props: IQuotaMetricGrid) => {
    const { quotaList = [] } = props;
    const keys = Object.keys(quotaList[0] || []);
    const gridColumns = useQuotaMetricColumns(keys);

    return <SimpleTable rowData={quotaList} gridColumns={gridColumns} />;
};

export default QuotaMetricGrid;
